import React from "react"
import styled from "@emotion/styled"
import { Link } from "gatsby"

const Container = styled.div`
  grid-column: 2;
  display: grid;
  align-items: center;
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    display: none;
  }
`
const CustomLink = styled(Link)`
  color: ${props => props.theme.shade[0]};
  font-weight: 300;
  text-decoration: none;
  position: relative;
  border-bottom: 2px solid transparent;
  &.active {
    font-weight: 800;
    border-bottom: 2px solid ${props => props.theme.shade[0]};
  }
`

const NavLinks = styled.div`
  display: grid;
  grid-auto-flow: column;
  justify-content: flex-end;
  align-items: center;
  gap: 24px;
`

export default function Menu({ isOpen }) {
  return (
    <Container isOpen={isOpen}>
      <NavLinks>
        <CustomLink activeClassName="active" to="/">
          Home
        </CustomLink>
        <CustomLink
          activeClassName="active"
          partiallyActive={true}
          to="/our-user-testing/"
        >
          Our user testing
        </CustomLink>
        <CustomLink
          activeClassName="active"
          partiallyActive={true}
          to="/how-we-do-it/"
        >
          How we do it
        </CustomLink>
        <CustomLink
          activeClassName="active"
          partiallyActive={true}
          to="/about/"
        >
          About
        </CustomLink>
        <CustomLink
          activeClassName="active"
          partiallyActive={true}
          to="/innovation-lab/"
        >
          Innovation Lab
        </CustomLink>
        <CustomLink
          activeClassName="active"
          partiallyActive={true}
          to="/contact/"
        >
          Contact
        </CustomLink>
      </NavLinks>
    </Container>
  )
}
